import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import LandingPage from "./pages/LandingPage";
import LoginPage from "./pages/LoginPage";
import DashboardLayout from "./pages/DashboardLayout";
import AppointmentsPage from "./pages/AppointmentsPage";
import ServicesPage from "./pages/ServicesPage";
import GalleryPage from "./pages/GalleryPage";
import ProfilePage from "./pages/ProfilePage";
import ContentEditorPage from "./pages/ContentEditorPage";
import SchedulePage from "./pages/SchedulePage";

function App() {
  return (
    <AuthProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<LandingPage />} />
            <Route path="/admin" element={<LoginPage />} />
            
            {/* Protected Dashboard Routes */}
            <Route path="/admin" element={<DashboardLayout />}>
              <Route path="dashboard" element={<AppointmentsPage />} />
              <Route path="services" element={<ServicesPage />} />
              <Route path="gallery" element={<GalleryPage />} />
              <Route path="profile" element={<ProfilePage />} />
              <Route path="content" element={<ContentEditorPage />} />
              <Route path="schedule" element={<SchedulePage />} />
            </Route>

            {/* Catch all */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </div>
    </AuthProvider>
  );
}

export default App;
